export default __webpack_public_path__ + "static/media/SEA_7366.73fc3d08.jpg";